import { TimeRecord } from '../types/timeRecord';

export const getEmptyTimeRecord = (date: string): TimeRecord => ({
  recordDate: date,
  amIn: '',
  amOut: '',
  pmIn: '',
  pmOut: '',
  otIn: '',
  otOut: '',
  salesAmount: 0,
  caAmount: 0,
  comments: ''
});